import React, { useState, useEffect, useContext } from 'react';
import './VehicleResult.scss';
import moment from 'moment';
import CustomDatePicker from './CustomDatePicker';
import Select from '@root/app/components/Forms/partials/Select';
import RentalInputsContext from '@app/context/rental/RentalInputsContext';

const VehicleDetails = () => {

  const { rentalInputs, setRentalInputs } = useContext(RentalInputsContext);

  const [Inputs, setInputs] = useState(rentalInputs);
  const [productTitleList, setProductList] = useState([]);
  const [pickupLocations, setPickupLocations] = useState([]);
  const [dropLocations, setDropLocations] = useState([]);

  const tripTypeOptions = {
    hourly: 'Local Rental',
    one_way: 'Outstation One-Way',
    round_trip: 'Outstation Round-Trip'
  };

  const getTripTypeKeyByLabel = (label) => {
    return Object.keys(tripTypeOptions).find(
      key => tripTypeOptions[key] === label
    );
  };

  const updateQueryParams = (key, value) => {
    const params = new URLSearchParams(window.location.search);
    params.set(key, value);
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.history.replaceState({}, '', newUrl);
  };

  const setAllQueryParams = (inputs) => {
    const params = new URLSearchParams();
    Object.entries(inputs).forEach(([key, value]) => {
      if (value !== undefined && value !== '') {
        params.set(key, value);
      }
    });
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.history.replaceState({}, '', newUrl);
  };

  const handleChange = (key, value) => {
    let formattedValue = value;

    if (key === 'start_date' || key === 'end_date') {
      // Format date to YYYY-MM-DD if it's a valid date
      const parsedDate = moment(value);
      if (parsedDate.isValid()) {
        formattedValue = parsedDate.format('YYYY-MM-DD');
      }
    }

    setInputs(prev => ({
      ...prev,
      [key]: formattedValue
    }));
    updateQueryParams(key, formattedValue);
  };

  const handleSearch = () => {
    setRentalInputs(Inputs);
  };

  useEffect(() => {
    setAllQueryParams(rentalInputs)
    setInputs(rentalInputs);
  }, [rentalInputs]);

  useEffect(() => {
    Promise.all([
      fetch('/get_city_list').then(res => res.json()),
      fetch('/rentals/get-rental-products').then(res => res.json())
    ])
      .then(([cityResData, productTitleResData]) => {
        if (cityResData?.code === 'success' && cityResData) {
          setPickupLocations(cityResData.data || []);
          setDropLocations(cityResData.data || []);
        }

        if (productTitleResData?.code === 'success' && Array.isArray(productTitleResData.data)) {
          const productTitleData = productTitleResData.data?.map(product => product.product_name_mm) || [];
          setProductList(productTitleData);
        }
      })
      .catch(err => console.error('Error fetching the data:', err));
  }, []);

  return (
    <div className="row">
      <div className="col-lg-12 vehicle-details">
        <div className="vehicle-details-wrapper">
          <h5 className="grey">Modify Your Vehicle Details</h5>

          <div className={`vehicle-grid ${Inputs?.trip_type}`}>
            <div className="rental-form">
              <Select
                className="form-control"
                name="tripType"
                values={Object.values(tripTypeOptions)}
                label="Booking Type"
                selectValue={tripTypeOptions[Inputs?.trip_type] || ''}
                onChange={event => {
                  const key = getTripTypeKeyByLabel(event.target.value);
                  handleChange('trip_type', key);
                }}
              />
            </div>

            <div className="rental-form">
              <Select
                className="form-control"
                name="car"
                values={productTitleList.length > 0 ? productTitleList : [Inputs.product_title]}
                label="Select Car"
                selectValue={Inputs?.product_title || ''}
                onChange={event => handleChange('product_title', event.target.value)}
              />
            </div>

            <div className="rental-form">
              <Select
                className="form-control"
                name="pickup"
                values={pickupLocations}
                label="Pickup Location"
                selectValue={Inputs?.start_city || ''}
                onChange={event => handleChange('start_city', event.target.value)}
              />
            </div>

            {Inputs.trip_type !== 'hourly' && ( <div className="rental-form">
              <Select
                className="form-control"
                name="drop"
                values={dropLocations}
                label="Drop Location"
                selectValue={Inputs?.end_city || ''}
                onChange={event => handleChange('end_city', event.target.value)}
              />
            </div>
           )}

            <div className="rental-form">
              <CustomDatePicker
                selectedDate={Inputs.start_date || ''}
                onChange={date => handleChange('start_date', moment(date).format('YYYY-MM-DD'))}
              />
            </div>

            {Inputs.trip_type === 'round_trip' && (
              <div className="rental-form">
                <CustomDatePicker
                  selectedDate={Inputs.end_date || ''}
                  onChange={date => handleChange('end_date', moment(date).format('YYYY-MM-DD'))}
                />
              </div>
            )}

            <div className="rental-form">
              <button className="btn btn-block btn-primary" id="check_price_lease" type="button" onClick={handleSearch}>
                Search
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VehicleDetails;